<ng-container *transloco="let t">
@if (application) {
  <div class="card mb-5 w-100">
    <div class="card-body px-2 pb-2">

      <!-- Mobile-only: Combined compact collapsible header (address + agent) -->
      <div class="mobile-combined-header d-none">
        <div class="mobile-combined-bar" tabindex="0" (click)="mobileInfoExpanded = !mobileInfoExpanded"
          (keyup.enter)="mobileInfoExpanded = !mobileInfoExpanded">
          <div class="mobile-bar-main">
            <div class="mobile-bar-address">{{ subjectPropertyAddress }}</div>
            @if (agentContactInfo) {
              <div class="mobile-bar-agent-row">
                <i class="fas fa-user-tie mobile-bar-agent-icon"></i>
                <span class="mobile-bar-agent">{{ agentContactInfo.firstName }} {{ agentContactInfo.lastName }}</span>
              </div>
            }
          </div>
          <div class="mobile-bar-right">
            <button type="button" class="mobile-bar-status"
              [ngbPopover]="application.blurb" [disablePopover]="!application.blurb"
              triggers="click" [autoClose]="'outside'" placement="bottom-end" container="body"
              popoverClass="loan-status-blurb-popover"
              (click)="onMobileStatusClicked($event)">{{ loanStatusDisplay || "-" }}</button>
            <i class="fas fa-chevron-down mobile-collapse-icon" [class.expanded]="mobileInfoExpanded"></i>
          </div>
        </div>

        <div class="mobile-combined-body" [class.expanded]="mobileInfoExpanded">
          <!-- Loan stats pills -->
          <div class="mobile-stats-strip">
            <div class="mobile-pill">
              <span class="mobile-pill-label">{{ t('portal.loanInfo.file') }}</span>
              <span class="mobile-pill-value">{{ (application?.refNumber || application?.applicationId) || "-" }}</span>
            </div>
            <div class="mobile-pill">
              <span class="mobile-pill-label">{{ t('portal.loanInfo.purpose') }}</span>
              <span class="mobile-pill-value">{{ loanPurposeDisplay || "-" }}</span>
            </div>
            @if (!application.loanAmountHiddenOnPortals) {
              <div class="mobile-pill">
                <span class="mobile-pill-label">{{ t('portal.loanInfo.amount') }}</span>
                <span class="mobile-pill-value">{{ application.loanAmount || 0 | currency }}</span>
              </div>
            }
            @if (!application.interestRateHiddenOnPortals) {
              <div class="mobile-pill">
                <span class="mobile-pill-label">{{ t('portal.loanInfo.rate') }}</span>
                <span class="mobile-pill-value">{{ application.interestRate || 0 }}%</span>
              </div>
            }
          </div>

          @if (isAgent && showBorrowerContactDetails && (primaryBorrower?.borrowerPhone || primaryBorrower?.borrowerEmail)) {
            <div class="mb-2">
              @if (primaryBorrower) {
                <ng-container>
                  @if (primaryBorrower.borrowerPhone) {
                    <a
                      href="tel:{{ primaryBorrower.borrowerPhone }}" class="me-4">
                      <i class="fa fa-phone"></i> {{ primaryBorrower.borrowerPhone | phone }}
                    </a>
                  }
                  @if (primaryBorrower.borrowerEmail) {
                    <a
                      href="mailto: {{ primaryBorrower.borrowerEmail }}">
                      <i class="fa fa-envelope"></i> {{ primaryBorrower.borrowerEmail }}
                    </a>
                  }
                </ng-container>
              }
            </div>
          }

          @if (!isAgent) {
            <div class="d-flex align-items-center mb-2">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="eConsentMobile{{application.applicationId}}"
                  name="eConsentMobile{{application.applicationId}}" [(ngModel)]="haveEConsent"
                  (ngModelChange)="onHaveEConsentChanged()">
                <label class="form-check-label" for="eConsentMobile{{application.applicationId}}">
                  {{ t('portal.loanInfo.eConsentAuthorized') }}
                </label>
              </div>
            </div>
          }

          <!-- Agent contact inline -->
          @if (agentContactInfo) {
            <div class="mobile-agent-inline">
              <agent-contact-info [agent]="agentContactInfo" (agentNameClicked)="onAgentNameClicked()"></agent-contact-info>
            </div>
          }

          @if (showViewTasksButton) {
            <div class="d-flex align-items-center gap-2 mt-2">
              @if (application.onlineAppInProgress) {
                <a href="javascript:void(0)" class="btn btn-sm btn-light"
                  (click)="goToCompleteApplication(application)">
                  <span class="indicator-label"> {{ t('portal.loanInfo.continueApp') }}</span>
                </a>
              }
              @if (!application.forceFinishOnlineApp && !isDetailView) {
                <a href="javascript:void(0)" class="btn btn-sm bp-primary-bg-color"
                  (click)="goToDetails(application)">{{ t('portal.loanInfo.open') }}</a>
              }
            </div>
          }
        </div>
      </div>

      <!-- Desktop: Original layout (hidden on mobile) -->
      <div class="d-flex flex-wrap flex-sm-nowrap d-revert desktop-loan-info">
        <!--begin: Pic-->
        <div class="ms-3 mt-3 me-3 mobile-picture-container">
          <div class="w-100 h-100 d-flex align-items-top justify-content-center address-image" href="javascript:void(0)">
            <div class="streetview-container" style="position: relative; display: inline-block;">
              <div id="pano_{{application.applicationId}}" class="pano-relative" [ngStyle]="{
                  width: isDetailView ? '220px' : '200px',
                  height: isDetailView ? '180px' : '200px',
                  display: 'inline-block',
                  position: 'relative',
                  overflow: 'visible'
                }"></div>
              @if (googleStreetViewUrl) {
                <a [href]="googleStreetViewUrl" target="_blank" rel="noopener noreferrer"
                  class="streetview-overlay-btn">
                  {{ t('portal.loanInfo.viewOnGoogleMaps') }}
                </a>
              }
              @if (showViewTasksButton) {
                <div class="loan-item-icons" [style.bottom]="googleStreetViewUrl ? '5px' : '0'">
                  <span class="position-relative" tabindex="0" (click)="goToDetails(application)" (keyup.enter)="goToDetails(application)">
                    <i class="fa fa-comment" style="font-size: 22px !important; color: #fff !important;"></i>
                    @if (totals[application.applicationId]?.messageCount > 0) {
                      <span
                        class="position-absolute px-1 py-1 top-1 start-100 translate-middle badge rounded-pill bg-danger">
                        {{ badgeLabel(totals[application.applicationId]?.messageCount) }}
                      </span>
                    }
                  </span>
                  <span class="position-relative" tabindex="0" (click)="goToDetails(application)" (keyup.enter)="goToDetails(application)">
                    <i class="fa fa-check-circle" style="font-size: 22px !important; color: #fff !important;"></i>
                    @if (totals[application.applicationId]?.taskCount > 0) {
                      <span
                        class="position-absolute px-1 py-1 top-1 start-100 translate-middle badge rounded-pill bg-danger">
                        {{ badgeLabel(totals[application.applicationId]?.taskCount) }}
                      </span>
                    }
                  </span>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="flex-grow-1">
          <div>
            <div>
              <div class="d-flex justify-content-between me-5 my-2 d-revert borrower-detail-section">
                <div>
                  @if (isDetailView) {
                    <span class="text-gray-900 fs-4 fw-bold me-1">
                      {{ subjectPropertyAddress }}
                    </span>
                  }
                  @if (!isDetailView) {
                    <a class="text-gray-900 fs-4 fw-bold me-1 text-hover-primary"
                      href="javascript:void(0)" (click)="goToDetails(application)">
                      {{ subjectPropertyAddress }}
                    </a>
                  }

                  @if (isAgent && showBorrowerContactDetails && (primaryBorrower?.borrowerPhone || primaryBorrower?.borrowerEmail)) {
                    <div>
                      @if (primaryBorrower) {
                        <ng-container>
                          @if (primaryBorrower.borrowerPhone) {
                            <a
                              href="tel:{{ primaryBorrower.borrowerPhone }}" class="me-6">
                              <i class="fa fa-phone"></i> {{ primaryBorrower.borrowerPhone | phone }}
                            </a>
                          }
                          @if (primaryBorrower.borrowerEmail) {
                            <a
                              href="mailto: {{ primaryBorrower.borrowerEmail }}">
                              <i class="fa fa-envelope"></i> {{ primaryBorrower.borrowerEmail }}
                            </a>
                          }
                        </ng-container>
                      }
                    </div>
                  }

                  @if (!isAgent) {
                    <div class="d-flex align-items-center mt-2">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="eConsentAuthorized{{application.applicationId}}"
                          name="eConsentAuthorized{{application.applicationId}}" [(ngModel)]="haveEConsent"
                          (ngModelChange)="onHaveEConsentChanged()">
                        <label class="form-check-label" for="eConsentAuthorized{{application.applicationId}}">
                          {{ t('portal.loanInfo.eConsentAuthorized') }}
                        </label>
                      </div>
                    </div>
                  }
                </div>
                <div class="button-section">
                  @if (showViewTasksButton) {
                    <div class="d-flex align-items-center justify-content-end">
                      @if (application.onlineAppInProgress) {
                        <a href="javascript:void(0)" class="btn btn-sm btn-light me-2"
                          (click)="goToCompleteApplication(application)">
                          <span class="svg-icon svg-icon-3 d-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path opacity="0.3"
                                d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z"
                                fill="currentColor"></path>
                              <path
                                d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z"
                                fill="currentColor"></path>
                            </svg>
                          </span>
                          <span class="indicator-label"> {{ t('portal.loanInfo.continueApp') }}</span>
                        </a>
                      }
                      @if (!application.forceFinishOnlineApp && !isDetailView) {
                        <a href="javascript:void(0)" class="btn btn-sm bp-primary-bg-color"
                          (click)="goToDetails(application)">{{ t('portal.loanInfo.open') }}</a>
                      }
                    </div>
                  }

                  <div class="d-flex align-items-center justify-content-end mt-2">
                    <span class="badge badge-light-success fs-base"
                      [ngbPopover]="application.blurb" [disablePopover]="!application.blurb"
                      triggers="mouseenter:mouseleave" placement="bottom-end" container="body"
                      popoverClass="loan-status-blurb-popover">
                      <i class="fs-5 text-success ms-n1"></i>
                      {{ loanStatusDisplay || "-" }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-wrap fw-semibold fs-6 mb-1 pe-2 d-revert">
                @if (isDetailView) {
                  <span class="d-flex align-items-center text-gray-400 mb-2 d-revert">
                    {{ applicationTitle }}
                  </span>
                }
                @if (!isDetailView) {
                  <a href="javascript:void(0)" (click)="goToDetails(application)"
                    class="d-flex align-items-center text-gray-400 text-hover-primary mb-2 d-revert">
                    {{ applicationTitle }}
                  </a>
                }
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap flex-stack align-items-end d-revert">
            <div class="d-flex flex-column flex-grow-1 pe-8 d-revert">
              <div class="d-flex flex-wrap gap-2 d-revert">
                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-xs-5">
                  <div class="d-flex text-start align-items-center">
                    <i class="fas fa-check-circle text-info me-3"></i>
                    <div class="fs-4 fw-bold counted " data-kt-countup="true" data-kt-countup-value="60"
                      data-kt-countup-prefix="%" data-kt-initialized="1">
                      {{ (application?.refNumber || application?.applicationId) || "-" }}
                    </div>
                  </div>
                  <div class="fw-semibold fs-6 text-gray-400 text-start">
                    {{ t('portal.loanInfo.fileNo') }}
                  </div>
                </div>
                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-xs-5">
                  <div class="d-flex text-start align-items-center">
                    <i class="fas fa-user-circle text-success me-3"></i>
                    <div class="fs-4 fw-bold counted " data-kt-countup="true" data-kt-countup-value="75"
                      data-kt-initialized="1">
                      {{ loanPurposeDisplay || "-" }}
                    </div>
                  </div>
                  <div class="fw-semibold fs-6 text-gray-400 text-start">
                    {{ t('portal.loanInfo.loanPurpose') }}
                  </div>
                </div>
                @if (!application.loanAmountHiddenOnPortals) {
                  <div class="min-w-125px py-3 px-4 mb-xs-5 border border-gray-300 border-dashed rounded">
                    <div class="d-flex align-items-center me-3">
                      <i class="fas fa-money-bill-alt text-primary me-3"></i>
                      <div class="fs-4 fw-bold counted" data-kt-countup="true" data-kt-countup-value="4500"
                        data-kt-countup-prefix="$" data-kt-initialized="1">
                        <span>{{ application.loanAmount || 0 | currency }}</span>
                      </div>
                    </div>
                    <div class="fw-semibold fs-6 text-gray-400 text-start">
                      {{ t('portal.loanInfo.loanAmount') }}
                    </div>
                  </div>
                }
                @if (!application.interestRateHiddenOnPortals) {
                  <div class="min-w-125px py-3 px-4 mb-xs-5 border border-gray-300 border-dashed rounded">
                    <div class="d-flex align-items-center me-3">
                      <i class="fas fa-chart-line text-success me-3"></i>
                      <div class="fs-4 fw-bold counted" data-kt-countup="true" data-kt-countup-value="60"
                        data-kt-countup-prefix="%" data-kt-initialized="1">
                        <span>{{ application.interestRate || 0 }} %</span>
                      </div>
                    </div>
                    <div class="fw-semibold fs-6 text-gray-400 text-start">
                      {{ t('portal.loanInfo.interestRate') }}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="desktop-agent-wrapper">
          <agent-contact-info [agent]="agentContactInfo" (agentNameClicked)="onAgentNameClicked()"></agent-contact-info>
        </div>
      </div>
    </div>
  </div>
}
</ng-container>
